import PropTypes from 'prop-types';
import { memo } from 'react';
import Row from './Row';

const SeatPicker = ({ seatmap, flight, canPickSeat, onSeatSelect }) =>
  seatmap &&
  seatmap.rows && (
    <>
      {!canPickSeat && (
        <div className="p-2 bg-yellow-300 text-yellow-900 my-5 mx-10 rounded-lg">
          This is a preview only — seat selection is available on the checkout page
        </div>
      )}
      {seatmap && !seatmap.isAnySeatsAvailable && (
        <div className="p-2 bg-red-100 text-red-400 my-5 mx-10 rounded-lg">
          There are no seats available for your selected fare class{' '}
          {flight.selectedFare.cabinClassName} Cabin
        </div>
      )}
      <table className="inline-block mt-10">
        <thead>
          <tr>
            <td>{}</td>
            <td>{}</td>
            <td colSpan={seatmap.rows[0].seats.length}>
              <div className="bg-body-0 text-gray-500">Front</div>
            </td>
          </tr>
        </thead>
        <tbody>
          {seatmap.rows.map((row) => (
            <Row
              row={row}
              key={row.rowNumber}
              wing={seatmap.wing}
              flight={flight}
              canPickSeat={canPickSeat}
              onSeatSelect={onSeatSelect}
            />
          ))}
        </tbody>
      </table>
    </>
  );

SeatPicker.propTypes = {
  canPickSeat: PropTypes.bool.isRequired,
  onSeatSelect: PropTypes.func.isRequired,
  flight: PropTypes.shape(PropTypes.shape({})).isRequired,
  seatmap: PropTypes.shape({
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        seats: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    ),
    wing: PropTypes.shape({
      firstRow: PropTypes.number,
      lastRow: PropTypes.number,
    }),
    isAnySeatsAvailable: PropTypes.bool,
  }).isRequired,
};

export default memo(SeatPicker);
